import React from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { 
  AppBar,
  Button,
  Toolbar,
  Typography,
  makeStyles } from '@material-ui/core'
import logo from '../../img/undp-logo.svg'
import { OPENID_CONNECT_FLOW, env } from '../../helpers/constants'
import { signout } from '../../reducers/auth/session'

const messages = {
  header: 'United Nations Development Programme ' + env,
  signin: 'SignIn',
  signout: 'SignOut',
  profile: 'Profile',
}

const drawerWidth = 280

const useStyles = makeStyles(theme => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    color: 'black',
    backgroundColor: '#F1F1F1'
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  title: {
    flex: 1,
    marginLeft: '10px',
  },
  link: {
    textDecoration: 'none', 
    color: 'black',
  },
  img: {
    height: '60px',
  },
  header: {
    fontSize: '12px',
    position: 'absolute', 
    top: '50%', 
    transform: 'translate(-50%, -50%)',
    marginLeft: 150
  },
}))

const CustomAppBar = (props) => {
    const { authorized, signout } = props
    const classes = useStyles()

    return (
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: false,
        })}
        elevation={1}
      >
        <Toolbar>
          <Typography variant="h6" noWrap className={classes.title}>
            <Link to={ (authorized) ? '/home' : '/'} className={classes.link}>
              <img src={logo} alt="Logo" className={classes.img} /> 
              <span className={classes.header} >{messages.header}</span>
            </Link>
          </Typography>
          { (authorized) ? 
            <Button color="inherit" onClick={() => { signout() }}>{messages.signout}</Button>
            : 
            <Button color="inherit" onClick= {() => { window.location.href = OPENID_CONNECT_FLOW }}>{messages.signin}</Button> }
        </Toolbar>
      </AppBar>
    )
}

const mapStateToProps = state => ({
  authorized: state.session.authorized,
})

const mapDispatchToProps = dispatch => ({
  signout: () => dispatch(signout()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomAppBar)